import { Ref } from 'vue';

export const useDigitsOnlyInput = (ref: Ref) => (event: Event) => {
  const input = event.target as HTMLInputElement;
  const sanitized = input.value.replace(/\D/g, '');

  if (sanitized !== input.value) {
    input.value = sanitized;
    input.dispatchEvent(new Event('input')); // ensures DOM and v-model sync
  }

  ref.value = sanitized; // updates VeeValidate field directly
};
